module.exports = __webpack_public_path__ + "static/media/omdb-movies-movie-details-desktop.31ad623a.jpg";